// These functions have different implementations between the web app and the desktop app.
// They must be initialized early in application initialization.

import { defineStore } from "pinia";
import { UserPreferences } from "./UserPreferences";
import { BooleanKey, RemoteVariables, StringKey } from "./RemoteVariables";

/// When the text is a valid page range, returns a negative number.
/// Otherwise returns the index of the first character that failed to parse.
export let pageRangeErrorIndex = (text: string) => {
    throw new Error("pageRangeErrorIndex() hasn't been set.");
    return Promise.resolve(0);
}

export function setPageRangeErrorIndex(f: (text: string) => Promise<number>): void {
    pageRangeErrorIndex = f;
}

export const useCurrentUser = defineStore('user', {
    state: () => ({id: null as null | string})
});

export let syncUserPreferences = (uid: string, localPreferences: UserPreferences): Promise<void> => {
    throw new Error("syncUserPreferences() hasn't been set.");
}

export function setSyncUserPreferences(
    f: (uid: string, localPreferences: UserPreferences) => Promise<void>): void
{
    syncUserPreferences = f;
}

export let remoteVariables: RemoteVariables = {
    getString: function (key: StringKey): string {
        throw new Error("remoteVariables hasn't been set.");
    },
    getBoolean: function (key: BooleanKey): boolean {
        // For pages like /adland, remote variables won't be loaded yet,
        // and it's better to show the page immediately than wait to show
        // the user some new tool they are unlikely to use.
        return false;
    },
    getStringAsync: function (key: StringKey): Promise<string> {
        throw new Error("remoteVariables hasn't been set.");
    },
    getBooleanAsync: function (key: BooleanKey): Promise<boolean> {
        throw new Error("remoteVariables hasn't been set.");
    }
};

export function setRemoteVariables(vars: RemoteVariables): void {
    remoteVariables = vars;
}

type PreviewHeaderFooterText = (text: string, file_name: string,
    out_file_name: string, page_number: number, page_count: number) => Promise<string>;

export let previewHeaderFooterText: PreviewHeaderFooterText = () => {
    throw new Error("previewHeaderFooterText hasn't been set.");
}

export function setPreviewHeaderFooterText(f: PreviewHeaderFooterText): void {
    previewHeaderFooterText = f;
}

type SyncToolboxWithCloud = (uid?: string) => Promise<void>;

export let syncToolboxWithCloud: SyncToolboxWithCloud = () => {
    throw new Error("syncToolboxWithCloud hasn't been set.");
}

export function setSyncToolboxWithCloud(f: SyncToolboxWithCloud): void {
    syncToolboxWithCloud = f;
}

type ReadFontFile = (path: string, hash: string) => Promise<ArrayBuffer|null>;

export let readFontFile: ReadFontFile = () => {
    throw new Error("readFontFile() hasn't been set.");
}

export function setReadFontFile(f: ReadFontFile): void {
    readFontFile = f;
}